import React, { useCallback, useMemo, useState } from 'react';
import { ICollapseProps } from './Collapse.types';
import { CollapseContext } from './context';

const Collapse: React.FC<ICollapseProps> = ({
  accordion = false,
  defaultActiveKey = [],
  activeKey,
  onChange,
  children
}) => {
  const [panel, setPanel] = useState<string[]>(defaultActiveKey);
  const isControlled = activeKey !== undefined;
  const current = isControlled ? (activeKey as string[]) : panel;
  const updatePanel = useCallback(
    (name: string) => {
      const computeNext = (prev: string[]) => {
        const index = prev.indexOf(name);

        if (accordion) {
          if (index > -1) {
            return [];
          }

          return [name];
        }

        if (index > -1) {
          const newPanel = [...prev];
          newPanel.splice(index, 1);
          return newPanel;
        }

        return [...prev, name];
      };

      const next = computeNext(current);
      if (isControlled) {
        onChange?.(next);
      } else {
        setPanel(next);
      }
    },
    [accordion, current, isControlled, onChange]
  );
  const context = useMemo(
    () => ({
      currentPanel: current,
      accordion,
      updatePanel
    }),
    [current, accordion, updatePanel]
  );

  return (
    <CollapseContext.Provider value={context}>
      {children}
    </CollapseContext.Provider>
  );
};

export default Collapse;
